import ModelBase, {IModelBase} from '@/models/ModelBase'
import User, { IUser } from '@/models/User'
import { KeyPair } from '@/types/KeyPair'
import Message, {IMessage} from '@/models/Message'

export interface IMessageUser extends IModelBase {
  user_id?: number
  user?: IUser
  message?: IMessage
  error?: string
}

export default class MessageUser extends ModelBase {
  user_id?: number
  user?: User
  message?: Message
  error?: string

  constructor(defaults?: IMessageUser) {
    super(defaults)
    if (defaults) {
      this.user_id = defaults.user_id
      this.user = defaults.user ? new User(defaults.user) : undefined
      this.message = defaults.message ? new Message(defaults.message) : undefined
      this.error = defaults.error
    }
  }

  get sentResult(): string {
    return this.error ? 'NG' : 'OK'
  }

  toParams(): KeyPair {
    return {}
  }
}
